import Modal from './Modal'
import VideoModal from './VideoModal'
export { VideoModal, Modal }
